import './App.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { AuthProvider } from '@/contexts/auth-context';
import { TrackerProvider } from '@/contexts/tracker-context';
import { EntranceProvider } from '@/components/entrance-tracker/context/entrance-context';
import { AppRouter } from '@/router';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TrackerProvider>
          <EntranceProvider>
            <AppRouter />
          </EntranceProvider>
        </TrackerProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
